import { render, staticRenderFns } from "./geofence-rules.vue?vue&type=template&id=3244e64a&"
import script from "./geofence-rules.vue?vue&type=script&lang=js&"
export * from "./geofence-rules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports